<template>
  <de-container>
    <de-aside-container type="panel">
      <div class="modelList">
        <div class="sideHead">
          <div class="typeName">{{ modelName }}</div>
          <el-input v-model="params.name" clearable size="small" placeholder="请输入模型名称" 
            @keyup.enter.native="handleSearch" @change="$forceUpdate()" style="color: #fff;"/>
        </div>
        <div class="list">
          <div 
            :class="['model',{'cur': item.id == id}]"
            v-for="(item,index) in modelList" 
            :key="index"
            @click="changModel(item.id,index)"
          >
            <el-image class="modelCover" :src="item.thumbnail" fit="cover"></el-image>
            <div class="modelName">{{ item.name }}</div>
          </div>
          <el-empty description="暂无数据" :image-size="100" v-if="!modelList.length"></el-empty>
        </div>
      </div>
    </de-aside-container>
    <de-main-container>
      <PanelViewShow
        @editPanel="editPanel"
        @editPanelBashInfo="editPanelBashInfo"
      />
    </de-main-container>
  </de-container>
</template>

<script>
import DeContainer from '@/components/dataease/DeContainer'
import PanelViewShow from '@/views/panel/list/PanelViewShow'
import DeMainContainer from '@/components/dataease/DeMainContainer'
import DeAsideContainer from '@/components/dataease/DeAsideContainer'

import bus from '@/utils/bus'
import * as API_DataModel from '@/api/datamodel/index'
import {
  addGroup,
  defaultTree,
  delGroup,
  groupTree,
  panelMove,
  panelToTop,
  panelUpdate,
  initPanelData,
  viewPanelLog
} from '@/api/panel/panel'

export default {
  components: { DeContainer,PanelViewShow,DeAsideContainer,DeMainContainer },
  data() {
    return {
      id: null,
      applyType: null,
      modelName: '',
      modelList: [],
      params: {
        name: '',
        applyType: null
      },
      dft: 'https://www.hashtagtreinamentos.com/wp-content/uploads/2020/05/O-que-e-o-Power-BI-1.png',
    };
  },
  computed: {
    modelParams() {
      return this.$store.state.panel.modelParams
    },
  },
  methods: {
    _getModelList() {
      API_DataModel.modelList(this.params).then(res => {
        if(res.success) {
          // console.log(res);
          this.modelList = res.data
        }
      })
    },
    modelDetail(id) {
      initPanelData(id, false, function(response) {
        // console.log(response);
        viewPanelLog({ panelId: id }).then((res) => {
          bus.$emit('set-panel-show-type', 0)
        })
      })
    },
    handleSearch() {
      this._getModelList()
    },
    changModel(id) {
      this.id = id
      this.modelDetail(id)
    }
  },
  mounted() {
    this.id = this.modelParams.id
    this.modelName = this.modelParams.typeName
    this.params.applyType = this.modelParams.applyType
    this.params.queryFrom = this.modelParams.queryFrom
    this._getModelList()
    this.modelDetail(this.id)
  },
};
</script>
<style lang='less' scoped>
.ms-aside-container {
  height: calc(100vh - 80px);
  padding: 0px;
  min-width: 260px;
  max-width: 460px;
}

.ms-main-container {
  height: calc(100vh - 80px);
  padding: 0px;
}
.modelList {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  .sideHead {
    width: 100%;
    padding: 10px;
  }
  .typeName {
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 32px;
    font-weight: bold;
  }
  .list {
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 0 10px;
    overflow-y: auto;
    // background-color: lightblue;
  }
  .model {
    width: 100%;
    // height: 300px;
    margin-bottom: 10px;
    border-radius: 4px;
    border: 1px solid #f4f4f4;
  }
  .model.cur {
    border-color: #1890FF;
    background-color: #c6e2ff;
  }
  .modelCover {
    width: 100%;
    height: 160px;
    display: block;
  }
  .modelName {
    height: 36px;
    padding: 0 10px;
    line-height: 36px;
  }
  .el-empty {
    margin-top: 160px;
  }
}
</style>
